$(document).on('click', '#toReview', function (e) {
	e.preventDefault();
//	smoothScroll.animateScroll($('#showReviewForm')[0], null, { "offset": -100 });
});

$(document).on('click', '#newReviewTop', function (e) {
	e.preventDefault();
	setTimeout(function () { $("#showReviewForm").trigger("click")}, 700);
//	smoothScroll.animateScroll($('#showReviewForm')[0], null, { "offset": -100 });
});